webpackJsonp([1],{

/***/ 255:
/***/ (function(module, exports) {

module.exports = {
	"COMPRESSED_TYPE_INVALID": "compressed should be a boolean",
	"EC_PRIVATE_KEY_TYPE_INVALID": "private key should be a Buffer",
	"EC_PRIVATE_KEY_LENGTH_INVALID": "private key length is invalid",
	"EC_PRIVATE_KEY_TWEAK_ADD_FAIL": "tweak out of range or resulting private key is invalid",
	"EC_PRIVATE_KEY_TWEAK_MUL_FAIL": "tweak out of range",
	"EC_PRIVATE_KEY_EXPORT_DER_FAIL": "couldn't export to DER format",
	"EC_PRIVATE_KEY_IMPORT_DER_FAIL": "couldn't import from DER format",
	"EC_PUBLIC_KEYS_TYPE_INVALID": "public keys should be an Array",
	"EC_PUBLIC_KEYS_LENGTH_INVALID": "public keys Array should have at least 1 element",
	"EC_PUBLIC_KEY_TYPE_INVALID": "public key should be a Buffer",
	"EC_PUBLIC_KEY_LENGTH_INVALID": "public key length is invalid",
	"EC_PUBLIC_KEY_PARSE_FAIL": "the public key could not be parsed or is invalid",
	"EC_PUBLIC_KEY_CREATE_FAIL": "private was invalid, try again",
	"EC_PUBLIC_KEY_TWEAK_ADD_FAIL": "tweak out of range or resulting public key is invalid",
	"EC_PUBLIC_KEY_TWEAK_MUL_FAIL": "tweak out of range",
	"EC_PUBLIC_KEY_COMBINE_FAIL": "the sum of the public keys is not valid",
	"ECDH_FAIL": "scalar was invalid (zero or overflow)",
	"ECDSA_SIGNATURE_TYPE_INVALID": "signature should be a Buffer",
	"ECDSA_SIGNATURE_LENGTH_INVALID": "signature length is invalid",
	"ECDSA_SIGNATURE_PARSE_FAIL": "couldn't parse signature",
	"ECDSA_SIGNATURE_PARSE_DER_FAIL": "couldn't parse DER signature",
	"ECDSA_SIGNATURE_SERIALIZE_DER_FAIL": "couldn't serialize signature to DER format",
	"ECDSA_SIGN_FAIL": "nonce generation function failed or private key is invalid",
	"ECDSA_RECOVER_FAIL": "couldn't recover public key from signature",
	"MSG32_TYPE_INVALID": "message should be a Buffer",
	"MSG32_LENGTH_INVALID": "message length is invalid",
	"OPTIONS_TYPE_INVALID": "options should be an Object",
	"OPTIONS_DATA_TYPE_INVALID": "options.data should be a Buffer",
	"OPTIONS_DATA_LENGTH_INVALID": "options.data length is invalid",
	"OPTIONS_NONCEFN_TYPE_INVALID": "options.noncefn should be a Function",
	"RECOVERY_ID_TYPE_INVALID": "recovery should be a Number",
	"RECOVERY_ID_VALUE_INVALID": "recovery should have value between -1 and 4",
	"TWEAK_TYPE_INVALID": "tweak should be a Buffer",
	"TWEAK_LENGTH_INVALID": "tweak length is invalid"
};

/***/ }),

/***/ 263:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(100);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(101);

var _vuex2 = _interopRequireDefault(_vuex);

var _mutations = __webpack_require__(287);

var _salePlugin = __webpack_require__(288);

var _salePlugin2 = _interopRequireDefault(_salePlugin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

exports.default = new _vuex2.default.Store({
  mutations: _mutations.mutations,
  state: _mutations.appState,
  plugins: [(0, _salePlugin2.default)()]
});

/***/ }),

/***/ 264:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(411)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(268),
  /* template */
  __webpack_require__(508),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 268:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_css_semantic_min_css__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_css_semantic_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_css_semantic_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_css_fonts_Maison_Neue_fonts_css__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_css_fonts_Maison_Neue_fonts_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_css_fonts_Maison_Neue_fonts_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hero__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hero___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Hero__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Media__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Media___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Media__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_SaleSummary__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_SaleSummary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_SaleSummary__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_TokenSummary__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_TokenSummary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_TokenSummary__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Docs__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Docs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Docs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Core__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Posts__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Posts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Posts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Team__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Team___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Team__);














/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    Hero: __WEBPACK_IMPORTED_MODULE_2__components_Hero___default.a,
    Media: __WEBPACK_IMPORTED_MODULE_3__components_Media___default.a,
    SaleSummary: __WEBPACK_IMPORTED_MODULE_4__components_SaleSummary___default.a,
    TokenSummary: __WEBPACK_IMPORTED_MODULE_5__components_TokenSummary___default.a,
    Docs: __WEBPACK_IMPORTED_MODULE_6__components_Docs___default.a,
    Core: __WEBPACK_IMPORTED_MODULE_7__components_Core___default.a,
    Posts: __WEBPACK_IMPORTED_MODULE_8__components_Posts___default.a,
    Team: __WEBPACK_IMPORTED_MODULE_9__components_Team___default.a
  },
  data: function data() {
    return {
      web3: undefined
    };
  }
});

/***/ }),

/***/ 269:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_DollarEthRate__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_DollarEthRate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__lib_DollarEthRate__);





var antEthRate = 100;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'conversor',
  methods: {
    buyTokens: function buyTokens() {
      if (this.$store.state.hadWeb3) {
        var amount = window.web3.toWei(this.ether, 'ether');
        window.web3.eth.getAccounts(function (err, accounts) {
          var from = accounts[0];
          var txBody = { from: from, to: __WEBPACK_IMPORTED_MODULE_0__config___default.a.tokenAddress, value: amount, gas: 2e5 };
          window.web3.eth.sendTransaction(txBody, function (e, x) {
            if (e) alert(e);
            var etherscanUrl = 'https://' + __WEBPACK_IMPORTED_MODULE_0__config___default.a.etherscanPrefix + 'etherscan.io/tx/' + x;
            var win = window.open(etherscanUrl, '_blank');
            if (win) {
              win.focus();
            } else {
              alert('Transaction sent, but your browser prevented opening a popup. Your transaction ID is: ' + x + ' (' + etherscanUrl + ')');
            }
          });
        });
      } else {
        document.getElementById('tutorials').scrollIntoView();
      }
    },
    setDollar: function setDollar(e) {
      var _this = this;

      this.dollar = e.target.value;
      __WEBPACK_IMPORTED_MODULE_1__lib_DollarEthRate___default()(function (rate) {
        _this.ether = e.target.value / rate;
        _this.ant = _this.ether * antEthRate;
      });
    },
    setEther: function setEther(e) {
      var _this2 = this;

      this.ether = e.target.value;
      this.ant = e.target.value * antEthRate;
      __WEBPACK_IMPORTED_MODULE_1__lib_DollarEthRate___default()(function (rate) {
        _this2.dollar = _this2.ether * rate;
      });
    },
    setANT: function setANT(e) {
      var _this3 = this;

      this.ant = e.target.value;
      this.ether = e.target.value / antEthRate;
      __WEBPACK_IMPORTED_MODULE_1__lib_DollarEthRate___default()(function (rate) {
        _this3.dollar = _this3.ether * rate;
      });
    }
  },
  data: function data() {
    return {
      dollar: 0,
      ether: 1,
      ant: 0
    };
  },

  computed: {
    termsAccepted: function termsAccepted() {
      return this.$store.state.termsAccepted;
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    this.ant = this.ether * antEthRate;
    __WEBPACK_IMPORTED_MODULE_1__lib_DollarEthRate___default()(function (rate) {
      _this4.dollar = _this4.ether * rate;
    });
  }
});

/***/ }),

/***/ 270:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'core'
});

/***/ }),

/***/ 271:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'disclaimer',
  methods: {
    setTermsAccepted: function setTermsAccepted(e) {
      this.$store.commit('setTermsAccepted', e.target.checked);
    }
  }
});

/***/ }),

/***/ 272:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'docs'
});

/***/ }),

/***/ 273:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__config__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ethAddress',
  data: function data() {
    return {
      tokenAddress: __WEBPACK_IMPORTED_MODULE_0__config___default.a.tokenAddress
    };
  },

  computed: {
    saleState: function saleState() {
      return 3;
    },
    termsAccepted: function termsAccepted() {
      return this.$store.state.termsAccepted;
    }
  }
});

/***/ }),

/***/ 274:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stats_Ether__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stats_Ether___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stats_Ether__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stats_Dollar__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stats_Dollar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__stats_Dollar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stats_Countdown__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stats_Countdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__stats_Countdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EthAddress__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EthAddress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__EthAddress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Conversor__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Conversor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Conversor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shifty__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shifty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Shifty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Disclaimer__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Disclaimer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Disclaimer__);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hero',
  components: {
    Ether: __WEBPACK_IMPORTED_MODULE_0__stats_Ether___default.a,
    Dollar: __WEBPACK_IMPORTED_MODULE_1__stats_Dollar___default.a,
    Countdown: __WEBPACK_IMPORTED_MODULE_2__stats_Countdown___default.a,

    EthAddress: __WEBPACK_IMPORTED_MODULE_3__EthAddress___default.a,
    Conversor: __WEBPACK_IMPORTED_MODULE_4__Conversor___default.a,
    Shifty: __WEBPACK_IMPORTED_MODULE_5__Shifty___default.a,
    Disclaimer: __WEBPACK_IMPORTED_MODULE_6__Disclaimer___default.a
  },
  computed: {
    saleState: function saleState() {
      return 3;
    },
    ready: function ready() {
      return this.$store.state.ready;
    },
    termsAccepted: function termsAccepted() {
      return this.$store.state.termsAccepted;
    }
  }
});

/***/ }),

/***/ 275:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'media'
});

/***/ }),

/***/ 276:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'posts'
});

/***/ }),

/***/ 277:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'saleSummary'
});

/***/ }),

/***/ 278:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'shifty',
  methods: {
    open: function open(e) {
      e.preventDefault();
      var href = 'https://shifty.aragon.one';
      window.open(href, '1418115287605', 'width=400,height=600,toolbar=0,menubar=0,location=0,status=1,scrollbars=1,resizable=0');
      return false;
    }
  },
  computed: {
    termsAccepted: function termsAccepted() {
      return this.$store.state.termsAccepted;
    }
  }
});

/***/ }),

/***/ 279:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'team'
});

/***/ }),

/***/ 280:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'tokenSummary',
  methods: {
    expandGraph: function expandGraph() {
      window.$('.tokenGraph').toggleClass('sixteen wide');
    }
  }
});

/***/ }),

/***/ 281:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'countdown',
  computed: {
    count: function count() {
      if (!this.$store.state.saleState.nextImportantTime) {
        return 0;
      }

      var time = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.$store.state.saleState.nextImportantTime);
      var diff = time.diff(__WEBPACK_IMPORTED_MODULE_0_moment___default.a.now());
      var duration = __WEBPACK_IMPORTED_MODULE_0_moment___default.a.duration(diff);
      return {
        days: duration.days(),
        hours: duration.hours(),
        minutes: duration.minutes(),
        seconds: duration.seconds()
      };
    },
    remainingSeconds: function remainingSeconds() {
      return this.$store.state.saleState.remainingSeconds;
    },
    saleState: function saleState() {
      return 3;
    },
    initialBlock: function initialBlock() {
      return this.$store.state.stats.initialBlock;
    },
    capRevealed: function capRevealed() {
      return this.$store.state.stats.capRevealed;
    },
    cap: function cap() {
      return this.$store.state.stats.cap;
    }
  },
  mounted: function mounted() {
    var _this = this;

    setInterval(function () {
      if (_this.count.minutes < 1) {
        var remainingSeconds = _this.$store.state.saleState.remainingSeconds;
        if (remainingSeconds === -1) remainingSeconds = _this.count.seconds;
        if (remainingSeconds > 0) {
          _this.$store.commit('setRemainingSeconds', remainingSeconds - 1);
        }
      }
    }, 1000);
  }
});

/***/ }),

/***/ 282:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'dollar',
  computed: {
    count: function count() {
      var dollar = this.$store.state.stats.dollar;
      return dollar.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
  }
});

/***/ }),

/***/ 283:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ether',
  computed: {
    count: function count() {
      return this.$store.state.stats.ether.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
  }
});

/***/ }),

/***/ 284:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _truffleContract = __webpack_require__(473);

var _truffleContract2 = _interopRequireDefault(_truffleContract);

var _config = __webpack_require__(38);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AragonTokenSale = (0, _truffleContract2.default)({
  abi: JSON.parse(_config2.default.saleABI),
  unlinked_binary: '0x6061' });

if (window.web3) {
  AragonTokenSale.setProvider(window.web3.currentProvider);
}

exports.default = AragonTokenSale;

/***/ }),

/***/ 285:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var exchangeRate = 0;

var getExchangeRate = function getExchangeRate(cb) {
  if (exchangeRate) {
    cb(exchangeRate);
  } else {
    var http = new XMLHttpRequest();
    http.onreadystatechange = function () {
      if (http.readyState === 4 && http.status === 200) {
        var res = JSON.parse(http.responseText);
        var rate = parseFloat(res.data.amount);

        exchangeRate = rate;
        cb(rate);
      }
    };
    http.open('GET', 'https://api.coinbase.com/v2/prices/ETH-USD/buy', true);
    http.send();
  }
};

exports.default = getExchangeRate;

/***/ }),

/***/ 286:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(100);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(101);

var _vuex2 = _interopRequireDefault(_vuex);

var _App = __webpack_require__(264);

var _App2 = _interopRequireDefault(_App);

var _store = __webpack_require__(263);

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.config.productionTip = false;

_vue2.default.use(_vuex2.default);

new _vue2.default({
  el: '#app',
  store: _store2.default,
  render: function render(h) {
    return h(_App2.default);
  }
});

/***/ }),

/***/ 287:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mutations = exports.appState = undefined;

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _config = __webpack_require__(38);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var saleStates = {
  presale: 1,
  sale: 2,
  aftersale: 3
};

var appState = exports.appState = {
  hadWeb3: false,
  stats: {
    ether: '...',
    dollar: '...',
    currentBlock: 1000000,
    initialBlock: 1,
    finalBlock: 2
  },
  saleState: {
    state: saleStates.presale,
    nextImportantTime: new Date(),
    remainingSeconds: -1
  },
  exchangeRate: 0,
  termsAccepted: false,
  ready: false
};

var calculateBlockTime = function calculateBlockTime(from, to) {
  if (from < to) return new Date();

  var t = (from - to - 1) * _config2.default.blockTime;
  return new Date(+new Date() + 1000 * t);
};

var calculateRemainingSecs = function calculateRemainingSecs(to) {
  var time = (0, _moment2.default)(to);
  var diff = time.diff(_moment2.default.now());
  var duration = _moment2.default.duration(diff);
  return duration.seconds();
};

var determineSaleState = function determineSaleState(state) {
  if (state.stats.initialBlock === 0 || state.stats.currentBlock === 0) {
    state.saleState.state = saleStates.presale;
    return;
  }

  if (state.stats.currentBlock < state.stats.initialBlock - 1) {
    state.saleState.state = saleStates.presale;
    var _t = calculateBlockTime(state.stats.initialBlock, state.stats.currentBlock);
    state.saleState.nextImportantTime = _t;
    state.saleState.remainingSeconds = calculateRemainingSecs(_t);
    return;
  }

  if (state.stats.currentBlock > state.stats.finalBlock || state.stats.ether >= state.stats.cap && state.stats.ether > 0) {
    state.saleState.state = saleStates.aftersale;
    state.saleState.nextImportantTime = null;
    return;
  }

  state.saleState.state = saleStates.sale;
  var t = calculateBlockTime(state.stats.finalBlock, state.stats.currentBlock);
  state.saleState.nextImportantTime = t;
  state.saleState.remainingSeconds = calculateRemainingSecs(t);
};

var mutations = exports.mutations = {
  setTotalCollected: function setTotalCollected(state, _ref) {
    var ether = _ref.ether;

    state.stats.ether = parseInt(ether, 10);
    determineSaleState(state);

    state.stats.dollar = parseInt(ether * 90, 10);
  },
  setCurrentBlock: function setCurrentBlock(state, _ref2) {
    var blockNumber = _ref2.blockNumber;

    state.stats.currentBlock = blockNumber;
    determineSaleState(state);
  },
  setSaleBlocks: function setSaleBlocks(state, _ref3) {
    var initialBlock = _ref3.initialBlock,
        finalBlock = _ref3.finalBlock;

    state.stats.initialBlock = initialBlock;
    state.stats.finalBlock = finalBlock;
    determineSaleState(state);
    state.ready = true;
  },
  setHadWeb3: function setHadWeb3(state, hadWeb3) {
    state.hadWeb3 = hadWeb3;
  },
  setCap: function setCap(state, _ref4) {
    var cap = _ref4.cap,
        revealed = _ref4.revealed;

    state.stats.cap = parseInt(cap, 10);
    state.stats.capRevealed = revealed;
    determineSaleState(state);
  },
  setTermsAccepted: function setTermsAccepted(state, accepted) {
    state.termsAccepted = accepted;
  },
  setRemainingSeconds: function setRemainingSeconds(state, seconds) {
    state.saleState.remainingSeconds = seconds;
  }
};

/***/ }),

/***/ 288:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(109);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = __webpack_require__(68);

var _promise2 = _interopRequireDefault(_promise);

var _asyncToGenerator2 = __webpack_require__(108);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

exports.default = watchSale;

var _web = __webpack_require__(95);

var _web2 = _interopRequireDefault(_web);

var _AragonTokenSale = __webpack_require__(284);

var _AragonTokenSale2 = _interopRequireDefault(_AragonTokenSale);

var _config = __webpack_require__(38);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProviderEngine = __webpack_require__(289);
var CacheSubprovider = __webpack_require__(291);
var FixtureSubprovider = __webpack_require__(293);
var FilterSubprovider = __webpack_require__(292);
var RpcSubprovider = __webpack_require__(294);

var hadWeb3 = false;

var isSafari = function isSafari() {
  return navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1;
};

var getNetwork = function () {
  var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt('return', new _promise2.default(function (resolve) {
              if (!window.web3) {
                resolve(undefined);
              } else {
                window.web3.version.getNetwork(function (error, result) {
                  resolve(result);
                });
              }
            }));

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function getNetwork() {
    return _ref.apply(this, arguments);
  };
}();

var loadWeb3 = function () {
  var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
    var network, engine;
    return _regenerator2.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!isSafari()) {
              _context2.next = 3;
              break;
            }

            window.web3 = new _web2.default(new _web2.default.providers.HttpProvider(_config2.default.node));
            return _context2.abrupt('return');

          case 3:
            _context2.next = 5;
            return getNetwork();

          case 5:
            network = _context2.sent;

            if (network === _config2.default.networkId) {
              hadWeb3 = true;
              window.web3 = new _web2.default(window.web3.currentProvider);
            } else {
              engine = new ProviderEngine();

              window.web3 = new _web2.default(engine);

              engine.addProvider(new FixtureSubprovider({
                web3_clientVersion: 'ProviderEngine/v0.0.0/javascript',
                net_listening: true,
                eth_hashrate: '0x00',
                eth_mining: false,
                eth_syncing: true
              }));

              engine.addProvider(new CacheSubprovider());

              engine.addProvider(new FilterSubprovider());

              engine.addProvider(new RpcSubprovider({
                rpcUrl: _config2.default.node
              }));

              engine.on('error', function (err) {
                console.error(err.stack);
              });

              engine.start();
            }

          case 7:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, undefined);
  }));

  return function loadWeb3() {
    return _ref2.apply(this, arguments);
  };
}();

var updateCollected = function () {
  var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(store, sale) {
    var w;
    return _regenerator2.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return sale.totalCollected();

          case 2:
            w = _context3.sent;

            store.commit('setTotalCollected', { ether: window.web3.fromWei(w).toFixed(2) });

          case 4:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, undefined);
  }));

  return function updateCollected(_x, _x2) {
    return _ref3.apply(this, arguments);
  };
}();

var updateCap = function () {
  var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4(store, sale, revealed) {
    var w;
    return _regenerator2.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return sale.hardCap();

          case 2:
            w = _context4.sent;

            store.commit('setCap', {
              cap: window.web3.fromWei(w).toFixed(2),
              revealed: revealed
            });

          case 4:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, undefined);
  }));

  return function updateCap(_x3, _x4, _x5) {
    return _ref4.apply(this, arguments);
  };
}();

var getBlock = function getBlock(blockHash) {
  return new _promise2.default(function (resolve, reject) {
    window.web3.eth.getBlock(blockHash, function (err, block) {
      if (err) reject(err);
      resolve(block);
    });
  });
};

var start = function () {
  var _ref5 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6(store) {
    var saleContract, blocks;
    return _regenerator2.default.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return loadWeb3();

          case 2:
            store.commit('setHadWeb3', hadWeb3);

            _AragonTokenSale2.default.setProvider(window.web3.currentProvider);
            saleContract = _AragonTokenSale2.default.at(_config2.default.saleAddress);


            saleContract.NewBuyer({}).watch(function (err, ev) {
              if (!err && ev) updateCollected(store, saleContract);
            });
            updateCollected(store, saleContract);

            saleContract.CapRevealed({}).watch(function (err, ev) {
              if (!err && ev) {
                updateCap(store, saleContract, true);
              }
            });
            updateCap(store, saleContract);

            window.web3.eth.getBlockNumber(function (er, b) {
              return store.commit('setCurrentBlock', { blockNumber: b });
            });

            window.web3.eth.filter('latest', function () {
              var _ref6 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5(err, blockHash) {
                var block;
                return _regenerator2.default.wrap(function _callee5$(_context5) {
                  while (1) {
                    switch (_context5.prev = _context5.next) {
                      case 0:
                        if (!err) {
                          _context5.next = 2;
                          break;
                        }

                        return _context5.abrupt('return');

                      case 2:
                        _context5.next = 4;
                        return getBlock(blockHash);

                      case 4:
                        block = _context5.sent;

                        store.commit('setCurrentBlock', { blockNumber: block.number });

                      case 6:
                      case 'end':
                        return _context5.stop();
                    }
                  }
                }, _callee5, undefined);
              }));

              return function (_x7, _x8) {
                return _ref6.apply(this, arguments);
              };
            }());

            _context6.next = 13;
            return _promise2.default.all([saleContract.initialBlock(), saleContract.finalBlock()]);

          case 13:
            blocks = _context6.sent;

            store.commit('setSaleBlocks', {
              initialBlock: blocks[0].toNumber(),
              finalBlock: blocks[1].toNumber()
            });

          case 15:
          case 'end':
            return _context6.stop();
        }
      }
    }, _callee6, undefined);
  }));

  return function start(_x6) {
    return _ref5.apply(this, arguments);
  };
}();

function watchSale() {
  return function (store) {
    setTimeout(function () {
      return start(store);
    }, 1000);
    if (isSafari()) {
      setInterval(function () {
        return start(store);
      }, 15 * 1000);
    }
  };
}

/***/ }),

/***/ 38:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  shapeShiftPubkey: '84e5d499dd96f84a3b66ec2aefe2d5b87651b75a4d454861fb2b7d2439e6109740e67c1da8d259f2053214e49d834f3cf8ef6c1773e8b5eb3b78beee504e26ee',
  node: 'https://mainnet.infura.io/',
  networkId: '1',
  blockTime: 15.99,
  saleAddress: '0x0ceb0d54a7e87dfa16ddf7656858cf7e29851fd7',
  tokenAddress: '0x960b236a07cf122663c4303350609a66a7b288c0',
  etherscanPrefix: '',
  saleABI: '[{"constant":true,"inputs":[],"name":"capCommitment","outputs":[{"name":"","type":"bytes32"}],"payable":false,"type":"function"},{"constant":true,"inputs":[],"name":"initialPrice","outputs":[{"name":"","type":"uint256"}],"payable":false,"type":"function"},{"constant":true,"inputs":[],"name":"finalBlock","outputs":[{"name":"","type":"uint256"}],"payable":false,"type":"function"},{"constant":false,"inputs":[],"name":"emergencyStopSale","outputs":[],"payable":false,"type":"function"},{"constant":true,"inputs":[],"name":"initialBlock","outputs":[{"name":"","type":"uint256"}],"payable":false,"type":"function"},{"constant":true,"inputs":[],"name":"communityMultisig","outputs":[{"name":"","type":"address"}],"payable":false,"type":"function"},{"constant":true,"inputs":[{"name":"_blockNumber","type":"uint256"}],"name":"stageForBlock","outputs":[{"name":"","type":"uint8"}],"payable":false,"type":"function"},{"constant":true,"inputs":[],"name":"getBlockNumber","outputs":[{"name":"","type":"uint256"}],"payable":false,"type":"function"},{"constant":true,"inputs":[],"name":"saleStopped","outputs":[{"name":"","type":"bool"}],"payable":false,"type":"function"},{"constant":false,"inputs":[{"name":"_from","type":"address"},{"name":"_to","type":"address"},{"name":"_amount","type":"uint256"}],"name":"onTransfer","outputs":[{"name":"","type":"bool"}],"payable":false,"type":"function"},{"constant":true,"inputs":[],"name":"isActivated","outputs":[{"name":"","type":"bool"}],"payable":false,"type":"function"},{"constant":true,"inputs":[],"name":"priceStages","outputs":[{"name":"","type":"uint8"}],"payable":false,"type":"function"},{"constant":false,"inputs":[{"name":"_newMultisig","type":"address"}],"name":"setCommunityMultisig","outputs":[],"payable":false,"type":"function"},{"constant":false,"inputs":[],"name":"restartSale","outputs":[],"payable":false,"type":"function"},{"constant":true,"inputs":[{"name":"","type":"address"}],"name":"activated","outputs":[{"name":"","type":"bool"}],"payable":false,"type":"function"},{"constant":true,"inputs":[],"name":"saleWallet","outputs":[{"name":"","type":"address"}],"payable":false,"type":"function"},{"constant":true,"inputs":[{"name":"_cap","type":"uint256"},{"name":"_cap_secure","type":"uint256"}],"name":"isValidCap","outputs":[{"name":"","type":"bool"}],"payable":false,"type":"function"},{"constant":false,"inputs":[{"name":"networkAddress","type":"address"}],"name":"deployNetwork","outputs":[],"payable":false,"type":"function"},{"constant":true,"inputs":[],"name":"saleFinalized","outputs":[{"name":"","type":"bool"}],"payable":false,"type":"function"},{"constant":true,"inputs":[],"name":"finalPrice","outputs":[{"name":"","type":"uint256"}],"payable":false,"type":"function"},{"constant":false,"inputs":[{"name":"_token","type":"address"},{"name":"_networkPlaceholder","type":"address"},{"name":"_saleWallet","type":"address"}],"name":"setANT","outputs":[],"payable":false,"type":"function"},{"constant":false,"inputs":[{"name":"_receiver","type":"address"},{"name":"_amount","type":"uint256"},{"name":"cliffDate","type":"uint64"},{"name":"vestingDate","type":"uint64"}],"name":"allocatePresaleTokens","outputs":[],"payable":false,"type":"function"},{"constant":true,"inputs":[{"name":"_cap","type":"uint256"},{"name":"_cap_secure","type":"uint256"}],"name":"computeCap","outputs":[{"name":"","type":"bytes32"}],"payable":false,"type":"function"},{"constant":false,"inputs":[],"name":"activateSale","outputs":[],"payable":false,"type":"function"},{"constant":true,"inputs":[],"name":"aragonDevMultisig","outputs":[{"name":"","type":"address"}],"payable":false,"type":"function"},{"constant":true,"inputs":[{"name":"_stage","type":"uint8"}],"name":"priceForStage","outputs":[{"name":"","type":"uint256"}],"payable":false,"type":"function"},{"constant":false,"inputs":[{"name":"_cap","type":"uint256"},{"name":"_cap_secure","type":"uint256"}],"name":"finalizeSale","outputs":[],"payable":false,"type":"function"},{"constant":false,"inputs":[{"name":"_newMultisig","type":"address"}],"name":"setAragonDevMultisig","outputs":[],"payable":false,"type":"function"},{"constant":false,"inputs":[{"name":"_owner","type":"address"},{"name":"_spender","type":"address"},{"name":"_amount","type":"uint256"}],"name":"onApprove","outputs":[{"name":"","type":"bool"}],"payable":false,"type":"function"},{"constant":true,"inputs":[],"name":"networkPlaceholder","outputs":[{"name":"","type":"address"}],"payable":false,"type":"function"},{"constant":true,"inputs":[],"name":"totalCollected","outputs":[{"name":"","type":"uint256"}],"payable":false,"type":"function"},{"constant":false,"inputs":[{"name":"_cap","type":"uint256"},{"name":"_cap_secure","type":"uint256"}],"name":"revealCap","outputs":[],"payable":false,"type":"function"},{"constant":true,"inputs":[{"name":"_blockNumber","type":"uint256"}],"name":"getPrice","outputs":[{"name":"","type":"uint256"}],"payable":false,"type":"function"},{"constant":false,"inputs":[{"name":"_owner","type":"address"}],"name":"proxyPayment","outputs":[{"name":"","type":"bool"}],"payable":true,"type":"function"},{"constant":true,"inputs":[],"name":"dust","outputs":[{"name":"","type":"uint256"}],"payable":false,"type":"function"},{"constant":true,"inputs":[],"name":"hardCap","outputs":[{"name":"","type":"uint256"}],"payable":false,"type":"function"},{"constant":true,"inputs":[],"name":"token","outputs":[{"name":"","type":"address"}],"payable":false,"type":"function"},{"inputs":[{"name":"_initialBlock","type":"uint256"},{"name":"_finalBlock","type":"uint256"},{"name":"_aragonDevMultisig","type":"address"},{"name":"_communityMultisig","type":"address"},{"name":"_initialPrice","type":"uint256"},{"name":"_finalPrice","type":"uint256"},{"name":"_priceStages","type":"uint8"},{"name":"_capCommitment","type":"bytes32"}],"payable":false,"type":"constructor"},{"payable":true,"type":"fallback"},{"anonymous":false,"inputs":[{"indexed":true,"name":"holder","type":"address"},{"indexed":false,"name":"antAmount","type":"uint256"}],"name":"NewPresaleAllocation","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"holder","type":"address"},{"indexed":false,"name":"antAmount","type":"uint256"},{"indexed":false,"name":"etherAmount","type":"uint256"}],"name":"NewBuyer","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"name":"value","type":"uint256"},{"indexed":false,"name":"secret","type":"uint256"},{"indexed":false,"name":"revealer","type":"address"}],"name":"CapRevealed","type":"event"}]'
};

/***/ }),

/***/ 400:
/***/ (function(module, exports) {

module.exports = {
	"_args": [
		[
			{
				"raw": "elliptic@^6.0.0",
				"scope": null,
				"escapedName": "elliptic",
				"name": "elliptic",
				"rawSpec": "^6.0.0",
				"spec": ">=6.0.0 <7.0.0",
				"type": "range"
			},
			"/Users/user/dev/aragon/sale/node_modules/browserify-sign"
		]
	],
	"_from": "elliptic@>=6.0.0 <7.0.0",
	"_id": "elliptic@6.4.0",
	"_inCache": true,
	"_location": "/elliptic",
	"_nodeVersion": "7.0.0",
	"_npmOperationalInternal": {
		"host": "packages-18-east.internal.npmjs.com",
		"tmp": "tmp/elliptic-6.4.0.tgz_1487798866428_0.30510620190761983"
	},
	"_npmUser": {
		"name": "indutny",
		"email": "fedor@indutny.com"
	},
	"_npmVersion": "3.10.8",
	"_phantomChildren": {},
	"_requested": {
		"raw": "elliptic@^6.0.0",
		"scope": null,
		"escapedName": "elliptic",
		"name": "elliptic",
		"rawSpec": "^6.0.0",
		"spec": ">=6.0.0 <7.0.0",
		"type": "range"
	},
	"_requiredBy": [
		"/browserify-sign",
		"/create-ecdh"
	],
	"_resolved": "https://registry.npmjs.org/elliptic/-/elliptic-6.4.0.tgz",
	"_shasum": "cac9af8762c85836187003c8dfe193e5e2eae5df",
	"_shrinkwrap": null,
	"_spec": "elliptic@^6.0.0",
	"_where": "/Users/user/dev/aragon/sale/node_modules/browserify-sign",
	"author": {
		"name": "Fedor Indutny",
		"email": "fedor@indutny.com"
	},
	"bugs": {
		"url": "https://github.com/indutny/elliptic/issues"
	},
	"dependencies": {
		"bn.js": "^4.4.0",
		"brorand": "^1.0.1",
		"hash.js": "^1.0.0",
		"hmac-drbg": "^1.0.0",
		"inherits": "^2.0.1",
		"minimalistic-assert": "^1.0.0",
		"minimalistic-crypto-utils": "^1.0.0"
	},
	"description": "EC cryptography",
	"devDependencies": {
		"brfs": "^1.4.3",
		"coveralls": "^2.11.3",
		"grunt": "^0.4.5",
		"grunt-browserify": "^5.0.0",
		"grunt-cli": "^1.2.0",
		"grunt-contrib-connect": "^1.0.0",
		"grunt-contrib-copy": "^1.0.0",
		"grunt-contrib-uglify": "^1.0.1",
		"grunt-mocha-istanbul": "^3.0.1",
		"grunt-saucelabs": "^8.6.2",
		"istanbul": "^0.4.2",
		"jscs": "^2.9.0",
		"jshint": "^2.6.0",
		"mocha": "^2.1.0"
	},
	"directories": {},
	"dist": {
		"shasum": "cac9af8762c85836187003c8dfe193e5e2eae5df",
		"tarball": "https://registry.npmjs.org/elliptic/-/elliptic-6.4.0.tgz"
	},
	"files": [
		"lib"
	],
	"gitHead": "6b0d2b76caae91471649c8e21f0b1d3ba0f96090",
	"homepage": "https://github.com/indutny/elliptic",
	"keywords": [
		"EC",
		"Elliptic",
		"curve",
		"Cryptography"
	],
	"license": "MIT",
	"main": "lib/elliptic.js",
	"maintainers": [
		{
			"name": "indutny",
			"email": "fedor@indutny.com"
		}
	],
	"name": "elliptic",
	"optionalDependencies": {},
	"readme": "ERROR: No README data found!",
	"repository": {
		"type": "git",
		"url": "git+ssh://git@github.com/indutny/elliptic.git"
	},
	"scripts": {
		"jscs": "jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js",
		"jshint": "jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js",
		"lint": "npm run jscs && npm run jshint",
		"test": "npm run lint && npm run unit",
		"unit": "istanbul test _mocha --reporter=spec test/index.js",
		"version": "grunt dist && git add dist/"
	},
	"version": "6.4.0"
};

/***/ }),

/***/ 406:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 407:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 408:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 409:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 410:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 411:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 412:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 413:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 414:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 415:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 416:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 417:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 418:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 419:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 420:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 421:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 441:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 137,
	"./af.js": 137,
	"./ar": 144,
	"./ar-dz": 138,
	"./ar-dz.js": 138,
	"./ar-kw": 139,
	"./ar-kw.js": 139,
	"./ar-ly": 140,
	"./ar-ly.js": 140,
	"./ar-ma": 141,
	"./ar-ma.js": 141,
	"./ar-sa": 142,
	"./ar-sa.js": 142,
	"./ar-tn": 143,
	"./ar-tn.js": 143,
	"./ar.js": 144,
	"./az": 145,
	"./az.js": 145,
	"./be": 146,
	"./be.js": 146,
	"./bg": 147,
	"./bg.js": 147,
	"./bn": 148,
	"./bn.js": 148,
	"./bo": 149,
	"./bo.js": 149,
	"./br": 150,
	"./br.js": 150,
	"./bs": 151,
	"./bs.js": 151,
	"./ca": 152,
	"./ca.js": 152,
	"./cs": 153,
	"./cs.js": 153,
	"./cv": 154,
	"./cv.js": 154,
	"./cy": 155,
	"./cy.js": 155,
	"./da": 156,
	"./da.js": 156,
	"./de": 159,
	"./de-at": 157,
	"./de-at.js": 157,
	"./de-ch": 158,
	"./de-ch.js": 158,
	"./de.js": 159,
	"./dv": 160,
	"./dv.js": 160,
	"./el": 161,
	"./el.js": 161,
	"./en-au": 162,
	"./en-au.js": 162,
	"./en-ca": 163,
	"./en-ca.js": 163,
	"./en-gb": 164,
	"./en-gb.js": 164,
	"./en-ie": 165,
	"./en-ie.js": 165,
	"./en-nz": 166,
	"./en-nz.js": 166,
	"./eo": 167,
	"./eo.js": 167,
	"./es": 169,
	"./es-do": 168,
	"./es-do.js": 168,
	"./es.js": 169,
	"./et": 170,
	"./et.js": 170,
	"./eu": 171,
	"./eu.js": 171,
	"./fa": 172,
	"./fa.js": 172,
	"./fi": 173,
	"./fi.js": 173,
	"./fo": 174,
	"./fo.js": 174,
	"./fr": 177,
	"./fr-ca": 175,
	"./fr-ca.js": 175,
	"./fr-ch": 176,
	"./fr-ch.js": 176,
	"./fr.js": 177,
	"./fy": 178,
	"./fy.js": 178,
	"./gd": 179,
	"./gd.js": 179,
	"./gl": 180,
	"./gl.js": 180,
	"./gom-latn": 181,
	"./gom-latn.js": 181,
	"./he": 182,
	"./he.js": 182,
	"./hi": 183,
	"./hi.js": 183,
	"./hr": 184,
	"./hr.js": 184,
	"./hu": 185,
	"./hu.js": 185,
	"./hy-am": 186,
	"./hy-am.js": 186,
	"./id": 187,
	"./id.js": 187,
	"./is": 188,
	"./is.js": 188,
	"./it": 189,
	"./it.js": 189,
	"./ja": 190,
	"./ja.js": 190,
	"./jv": 191,
	"./jv.js": 191,
	"./ka": 192,
	"./ka.js": 192,
	"./kk": 193,
	"./kk.js": 193,
	"./km": 194,
	"./km.js": 194,
	"./kn": 195,
	"./kn.js": 195,
	"./ko": 196,
	"./ko.js": 196,
	"./ky": 197,
	"./ky.js": 197,
	"./lb": 198,
	"./lb.js": 198,
	"./lo": 199,
	"./lo.js": 199,
	"./lt": 200,
	"./lt.js": 200,
	"./lv": 201,
	"./lv.js": 201,
	"./me": 202,
	"./me.js": 202,
	"./mi": 203,
	"./mi.js": 203,
	"./mk": 204,
	"./mk.js": 204,
	"./ml": 205,
	"./ml.js": 205,
	"./mr": 206,
	"./mr.js": 206,
	"./ms": 208,
	"./ms-my": 207,
	"./ms-my.js": 207,
	"./ms.js": 208,
	"./my": 209,
	"./my.js": 209,
	"./nb": 210,
	"./nb.js": 210,
	"./ne": 211,
	"./ne.js": 211,
	"./nl": 213,
	"./nl-be": 212,
	"./nl-be.js": 212,
	"./nl.js": 213,
	"./nn": 214,
	"./nn.js": 214,
	"./pa-in": 215,
	"./pa-in.js": 215,
	"./pl": 216,
	"./pl.js": 216,
	"./pt": 218,
	"./pt-br": 217,
	"./pt-br.js": 217,
	"./pt.js": 218,
	"./ro": 219,
	"./ro.js": 219,
	"./ru": 220,
	"./ru.js": 220,
	"./sd": 221,
	"./sd.js": 221,
	"./se": 222,
	"./se.js": 222,
	"./si": 223,
	"./si.js": 223,
	"./sk": 224,
	"./sk.js": 224,
	"./sl": 225,
	"./sl.js": 225,
	"./sq": 226,
	"./sq.js": 226,
	"./sr": 228,
	"./sr-cyrl": 227,
	"./sr-cyrl.js": 227,
	"./sr.js": 228,
	"./ss": 229,
	"./ss.js": 229,
	"./sv": 230,
	"./sv.js": 230,
	"./sw": 231,
	"./sw.js": 231,
	"./ta": 232,
	"./ta.js": 232,
	"./te": 233,
	"./te.js": 233,
	"./tet": 234,
	"./tet.js": 234,
	"./th": 235,
	"./th.js": 235,
	"./tl-ph": 236,
	"./tl-ph.js": 236,
	"./tlh": 237,
	"./tlh.js": 237,
	"./tr": 238,
	"./tr.js": 238,
	"./tzl": 239,
	"./tzl.js": 239,
	"./tzm": 241,
	"./tzm-latn": 240,
	"./tzm-latn.js": 240,
	"./tzm.js": 241,
	"./uk": 242,
	"./uk.js": 242,
	"./ur": 243,
	"./ur.js": 243,
	"./uz": 245,
	"./uz-latn": 244,
	"./uz-latn.js": 244,
	"./uz.js": 245,
	"./vi": 246,
	"./vi.js": 246,
	"./x-pseudo": 247,
	"./x-pseudo.js": 247,
	"./yo": 248,
	"./yo.js": 248,
	"./zh-cn": 249,
	"./zh-cn.js": 249,
	"./zh-hk": 250,
	"./zh-hk.js": 250,
	"./zh-tw": 251,
	"./zh-tw.js": 251
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 441;

/***/ }),

/***/ 471:
/***/ (function(module, exports) {

module.exports = {
	"_args": [
		[
			{
				"raw": "truffle-contract-schema@0.0.5",
				"scope": null,
				"escapedName": "truffle-contract-schema",
				"name": "truffle-contract-schema",
				"rawSpec": "0.0.5",
				"spec": "0.0.5",
				"type": "version"
			},
			"/Users/user/dev/aragon/sale/node_modules/truffle-contract"
		]
	],
	"_from": "truffle-contract-schema@0.0.5",
	"_id": "truffle-contract-schema@0.0.5",
	"_inCache": true,
	"_location": "/truffle-contract-schema",
	"_nodeVersion": "6.9.1",
	"_npmOperationalInternal": {
		"host": "packages-12-west.internal.npmjs.com",
		"tmp": "tmp/truffle-contract-schema-0.0.5.tgz_1485557985137_0.46875762194395065"
	},
	"_npmUser": {
		"name": "tcoulter",
		"email": "tim@timothyjcoulter.com"
	},
	"_npmVersion": "3.10.8",
	"_phantomChildren": {},
	"_requested": {
		"raw": "truffle-contract-schema@0.0.5",
		"scope": null,
		"escapedName": "truffle-contract-schema",
		"name": "truffle-contract-schema",
		"rawSpec": "0.0.5",
		"spec": "0.0.5",
		"type": "version"
	},
	"_requiredBy": [
		"/truffle-contract"
	],
	"_resolved": "https://registry.npmjs.org/truffle-contract-schema/-/truffle-contract-schema-0.0.5.tgz",
	"_shasum": "5e9d20bd0bf2a27fe94310748249d484eee49961",
	"_shrinkwrap": null,
	"_spec": "truffle-contract-schema@0.0.5",
	"_where": "/Users/user/dev/aragon/sale/node_modules/truffle-contract",
	"author": {
		"name": "Tim Coulter",
		"email": "tim.coulter@consensys.net"
	},
	"bugs": {
		"url": "https://github.com/trufflesuite/truffle-schema/issues"
	},
	"dependencies": {
		"crypto-js": "^3.1.9-1"
	},
	"description": "JSON schema for contract artifacts",
	"devDependencies": {
		"mocha": "^3.2.0"
	},
	"directories": {},
	"dist": {
		"shasum": "5e9d20bd0bf2a27fe94310748249d484eee49961",
		"tarball": "https://registry.npmjs.org/truffle-contract-schema/-/truffle-contract-schema-0.0.5.tgz"
	},
	"gitHead": "cfa4313bd4bb95bf5b94f85185203ead418f9ee6",
	"homepage": "https://github.com/trufflesuite/truffle-schema#readme",
	"keywords": [
		"ethereum",
		"json",
		"schema",
		"contract",
		"artifacts"
	],
	"license": "MIT",
	"main": "index.js",
	"maintainers": [
		{
			"name": "tcoulter",
			"email": "tim@timothyjcoulter.com"
		}
	],
	"name": "truffle-contract-schema",
	"optionalDependencies": {},
	"readme": "ERROR: No README data found!",
	"repository": {
		"type": "git",
		"url": "git+https://github.com/trufflesuite/truffle-schema.git"
	},
	"scripts": {
		"test": "mocha"
	},
	"version": "0.0.5"
};

/***/ }),

/***/ 474:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/devplan.584d7a2.png";

/***/ }),

/***/ 475:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/onepager.fd260f4.png";

/***/ }),

/***/ 476:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/whitepaper.d66fb22.png";

/***/ }),

/***/ 477:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/allocation.125b8ff.png";

/***/ }),

/***/ 478:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/coin.f300443.png";

/***/ }),

/***/ 479:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/iuor.ca8a4e8.png";

/***/ }),

/***/ 480:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 481:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/coinjournal.6153332.png";

/***/ }),

/***/ 482:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 483:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 484:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 485:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 490:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(417)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(269),
  /* template */
  __webpack_require__(515),
  /* scopeId */
  "data-v-64676531",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 491:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(419)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(270),
  /* template */
  __webpack_require__(518),
  /* scopeId */
  "data-v-7c97eb9a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 492:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(415)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(271),
  /* template */
  __webpack_require__(512),
  /* scopeId */
  "data-v-51c635a2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 493:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(409)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(272),
  /* template */
  __webpack_require__(506),
  /* scopeId */
  "data-v-10c1cecf",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 494:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(408)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(273),
  /* template */
  __webpack_require__(505),
  /* scopeId */
  "data-v-0fc68baf",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 495:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(420)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(274),
  /* template */
  __webpack_require__(519),
  /* scopeId */
  "data-v-8eaef5e4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 496:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(416)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(275),
  /* template */
  __webpack_require__(513),
  /* scopeId */
  "data-v-5597f080",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 497:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(413)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(276),
  /* template */
  __webpack_require__(510),
  /* scopeId */
  "data-v-4e716cef",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 498:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(414)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(277),
  /* template */
  __webpack_require__(511),
  /* scopeId */
  "data-v-4fc9ad0a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 499:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(278),
  /* template */
  __webpack_require__(514),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 500:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(279),
  /* template */
  __webpack_require__(517),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 501:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(410)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(280),
  /* template */
  __webpack_require__(507),
  /* scopeId */
  "data-v-13f89301",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 502:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(418)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(281),
  /* template */
  __webpack_require__(516),
  /* scopeId */
  "data-v-74c4e1dd",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 503:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(421)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(282),
  /* template */
  __webpack_require__(520),
  /* scopeId */
  "data-v-ab52a780",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 504:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(412)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(283),
  /* template */
  __webpack_require__(509),
  /* scopeId */
  "data-v-390fd19c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 505:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.saleState !== 3) ? _c('div', {
    staticClass: "ui left labeled fluid input"
  }, [_c('div', {
    staticClass: "ui basic label"
  }, [_vm._v("\n      Send your eth to\n    ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tokenAddress),
      expression: "tokenAddress"
    }],
    style: (_vm.termsAccepted ? '' : 'color:red'),
    attrs: {
      "type": "text",
      "readonly": "",
      "id": "tokenAddress"
    },
    domProps: {
      "value": (_vm.tokenAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tokenAddress = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('small', [_c('b', [_vm._v("DO NOT")]), _vm._v(" send ether from exchanges")])
}]}

/***/ }),

/***/ 506:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grey section"
  }, [_c('h1', {
    staticClass: "ui center aligned header"
  }, [_vm._v("\n    Relevant documents\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "ui middle aligned very relaxed center aligned stackable equal width grid container"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('a', {
    staticClass: "ui centered card",
    attrs: {
      "href": "https://github.com/aragon/docs/raw/master/Aragon-One-Pager.pdf",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('div', {
    staticClass: "center aligned content"
  }, [_c('img', {
    staticClass: "ui small middle aligned image",
    attrs: {
      "src": __webpack_require__(475)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _c('a', {
    staticClass: "center aligned header"
  }, [_vm._v("\n            One Pager\n            "), _c('br'), _vm._v(" "), _c('i', {
    staticClass: "us flag"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/aragon/docs/raw/master/Aragon-One-Pager-CN.pdf"
    }
  }, [_c('i', {
    staticClass: "cn flag"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/aragon/docs/raw/master/Aragon-One-Pager-RU.pdf"
    }
  }, [_c('i', {
    staticClass: "ru flag"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('a', {
    staticClass: "ui centered card",
    attrs: {
      "href": "https://github.com/aragon/whitepaper/raw/master/Aragon%20Whitepaper.pdf"
    }
  }, [_c('div', {
    staticClass: "center aligned content"
  }, [_c('img', {
    staticClass: "ui small middle aligned image",
    attrs: {
      "src": __webpack_require__(476)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _c('a', {
    staticClass: "center aligned header"
  }, [_vm._v("\n            Whitepaper\n            "), _c('br'), _vm._v(" "), _c('i', {
    staticClass: "us flag"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/aragon/whitepaper/raw/master/Aragon%20Whitepaper-CN.pdf"
    }
  }, [_c('i', {
    staticClass: "cn flag"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('a', {
    staticClass: "ui centered card",
    attrs: {
      "href": "https://github.com/aragon/docs/raw/master/Aragon-Development-Plan.pdf",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('div', {
    staticClass: "center aligned content"
  }, [_c('img', {
    staticClass: "ui small middle aligned image",
    attrs: {
      "src": __webpack_require__(474)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _c('a', {
    staticClass: "center aligned header"
  }, [_vm._v("\n            Development Plan\n            "), _c('br'), _vm._v(" "), _c('i', {
    staticClass: "us flag"
  })])])])])])])
}]}

/***/ }),

/***/ 507:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "ui middle aligned very relaxed center aligned stackable equal width grid container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "column tokenGraph"
  }, [_c('img', {
    staticClass: "ui fluid image",
    attrs: {
      "src": "https://docs.google.com/drawings/d/1nBxz5ji9qyrZOt2MOgTOpIwmctsEFI5HK3LzFxy1oVM/pub?w=1651&h=1489"
    },
    on: {
      "click": _vm.expandGraph
    }
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column"
  }, [_c('h1', {
    staticClass: "ui left aligned header"
  }, [_vm._v("\n        Token functionality\n        "), _c('div', {
    staticClass: "ui half hidden divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "sub header"
  }, [_vm._v("\n          The Aragon Network aims to be the first decentralized jurisdiction. It will provide an optimal environment for decentralized organizations to thrive, by offering services such as easy smart contract upgradeability and a decentralized court. Token holders will be able to:\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "ui list"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n            Change subscription fees and minting rate\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n            Decide which services to provide\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n            Vote on capital allocations or investments\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n            Self-upgrade the Network\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n            All other voting and governance decisions\n          ")])])])])
}]}

/***/ }),

/***/ 508:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('hero'), _vm._v(" "), _c('media'), _vm._v(" "), (_vm.web3 === undefined) ? _c('downloadWallet') : _vm._e(), _vm._v(" "), _c('saleSummary'), _vm._v(" "), _c('tokenSummary'), _vm._v(" "), _c('docs'), _vm._v(" "), _c('core'), _vm._v(" "), _c('posts'), _vm._v(" "), _c('team')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 509:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "statistic"
  }, [_c('div', {
    staticClass: "value"
  }, [_vm._v("\n    " + _vm._s(_vm.count) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("\n    ETH\n  ")])])
},staticRenderFns: []}

/***/ }),

/***/ 510:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "posts"
    }
  }, [_c('div', {
    staticClass: "ui stackable grid"
  }, [_c('div', {
    staticClass: "equal width row primary"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('a', {
    staticClass: "post first",
    attrs: {
      "href": "https://blog.aragon.one/introducing-the-aragon-network-20b998e2caba",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('h2', {
    staticClass: "ui inverted header"
  }, [_vm._v("\n            Introducing the Aragon Network\n            "), _c('div', {
    staticClass: "sub header"
  }, [_vm._v("Apr 14")])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('a', {
    staticClass: "post second",
    attrs: {
      "href": "https://blog.aragon.one/aragon-network-token-sale-terms-8998f63a3429",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('h2', {
    staticClass: "ui inverted header"
  }, [_vm._v("\n            Aragon Network Token sale terms\n            "), _c('div', {
    staticClass: "sub header"
  }, [_vm._v("Apr 21")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "equal width row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('a', {
    staticClass: "post third",
    attrs: {
      "href": "https://blog.aragon.one/announcing-the-aragon-network-token-sale-fe83fe36902c",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('h2', {
    staticClass: "ui inverted header"
  }, [_vm._v("\n            Announcing the Aragon Network token sale\n            "), _c('div', {
    staticClass: "sub header"
  }, [_vm._v("Apr 20")])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('a', {
    staticClass: "post fourth",
    attrs: {
      "href": "https://blog.aragon.one/introducing-the-aragon-development-plan-857fbbe90779",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('h2', {
    staticClass: "ui inverted header"
  }, [_vm._v("\n            Introducing the Aragon Development Plan\n            "), _c('div', {
    staticClass: "sub header"
  }, [_vm._v("Apr 24")])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('a', {
    staticClass: "post fifth",
    attrs: {
      "href": "https://blog.aragon.one/the-path-to-mainstream-decentralized-organizations-d95a89d3cac4",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('h2', {
    staticClass: "ui inverted header"
  }, [_vm._v("\n            The path to mainstream decentralized organizations\n            "), _c('div', {
    staticClass: "sub header"
  }, [_vm._v("Apr 25")])])])])])])])
}]}

/***/ }),

/***/ 511:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section"
  }, [_c('h1', {
    staticClass: "ui center aligned header"
  }, [_vm._v("\n    Sale summary\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "ui bottom aligned very relaxed center aligned stackable equal width grid container"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('img', {
    staticClass: "ui fluid image",
    attrs: {
      "src": __webpack_require__(479)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _c('p', [_vm._v("Intended use of revenue")])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('img', {
    staticClass: "ui fluid image",
    attrs: {
      "src": __webpack_require__(477)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _c('p', [_vm._v("Token distribution")])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('code', [_vm._v("\n        1 ether = 100 ANT\n        "), _c('small', [_vm._v("first 2 weeks")])]), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _c('code', [_vm._v("\n        1 ether = 66 ANT\n        "), _c('small', [_vm._v("last 2 weeks")])]), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _c('code', [_vm._v("\n        Hidden cap\n        "), _c('small', [_vm._v("Will be revealed during the sale or prior to being reached")])]), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _c('p', [_vm._v("Token price and duration")])])])])
}]}

/***/ }),

/***/ 512:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "ui checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "termsAccepted"
    },
    on: {
      "change": _vm.setTermsAccepted
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("By participating in the sale, you agree to its "), _c('a', {
    staticClass: "aragon underline",
    attrs: {
      "href": "/static/terms.pdf"
    }
  }, [_vm._v("terms and conditions")])])
}]}

/***/ }),

/***/ 513:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "ui container"
  }, [_c('div', {
    staticClass: "ui stackable equal width grid"
  }, [_c('div', {
    staticClass: "equal width row primary"
  }, [_c('div', {
    staticClass: "middle aligned column"
  }, [_c('a', {
    attrs: {
      "href": "http://www.coindesk.com/dao-manager-aragon-alpha-ethereum/",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('img', {
    staticClass: "ui fluid tiny centered image",
    attrs: {
      "src": __webpack_require__(480)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "middle aligned column"
  }, [_c('a', {
    attrs: {
      "href": "https://www.financemagnates.com/cryptocurrency/news/dao-reborn-aragon-launches-crowdsale-decentralized-organizations/",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('img', {
    staticClass: "ui fluid tiny centered image",
    attrs: {
      "src": __webpack_require__(483)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "middle aligned column"
  }, [_c('a', {
    attrs: {
      "href": "https://www.forbes.com/sites/rogeraitken/2017/04/20/forbes-under-30-tech-prodigy-in-cryptosale-for-decentralized-jurisdiction-platform/#3ac1df126a12",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('img', {
    staticClass: "ui fluid tiny centered image",
    attrs: {
      "src": __webpack_require__(484)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "middle aligned column"
  }, [_c('a', {
    attrs: {
      "href": "https://cointelegraph.com/news/spains-aragon-joins-ethereum-startups-eyeing-token-sale-glory",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('img', {
    staticClass: "ui fluid tiny centered image",
    attrs: {
      "src": __webpack_require__(482)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "middle aligned column"
  }, [_c('a', {
    attrs: {
      "href": "https://finance.yahoo.com/m/12f8484f-3af2-370d-b6e7-f2cada14bf5f/forbes-%27under-30%27-tech.html",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('img', {
    staticClass: "ui fluid tiny centered image",
    attrs: {
      "src": __webpack_require__(485)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "middle aligned column"
  }, [_c('a', {
    attrs: {
      "href": "http://coinjournal.net/ethereum-platform-aragon-power-next-gen-decentralized-organizations/",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('img', {
    staticClass: "ui fluid tiny centered image",
    attrs: {
      "src": __webpack_require__(481)
    }
  })])])])])])])
}]}

/***/ }),

/***/ 514:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _c('a', {
    staticClass: "ui basic inverted button",
    class: _vm.termsAccepted ? '' : 'disabled',
    attrs: {
      "href": "https://shifty.aragon.one"
    },
    on: {
      "click": _vm.open
    }
  }, [_vm._v("Buy with other cryptocurrencies")])])
},staticRenderFns: []}

/***/ }),

/***/ 515:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui text container",
    attrs: {
      "id": "conversor"
    }
  }, [_c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "ui one column center aligned grid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "ui basic fluid label top attached"
  }, [_vm._v("\n        Choose how much you want to buy\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "ui three equal width grid"
  }, [_c('div', {
    staticClass: "ui column big input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dollar),
      expression: "dollar"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.dollar)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.dollar = $event.target.value
      }, _vm.setDollar],
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("USD")])]), _vm._v(" "), _c('div', {
    staticClass: "ui column big input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ether),
      expression: "ether"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.ether)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.ether = $event.target.value
      }, _vm.setEther],
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("ETH")])]), _vm._v(" "), _c('div', {
    staticClass: "ui column big input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ant),
      expression: "ant"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.ant)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.ant = $event.target.value
      }, _vm.setANT],
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("ANT")])])])]), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _c('button', {
    staticClass: "ui huge center aligned fluid inverted basic button",
    class: _vm.termsAccepted ? '' : 'disabled',
    on: {
      "click": _vm.buyTokens
    }
  }, [_vm._v("Buy tokens")])])])
},staticRenderFns: []}

/***/ }),

/***/ 516:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "statistic"
  }, [_c('div', {
    staticClass: "value"
  }, [(_vm.saleState === 1) ? _c('span', [(_vm.count.days) ? _c('span', [_vm._v("\n        " + _vm._s(_vm.count.days) + " "), _c('span', {
    staticClass: "time"
  }, [_vm._v("day"), (_vm.count.days > 1) ? _c('span', [_vm._v("s")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.count.hours) ? _c('span', [_vm._v("\n        " + _vm._s(_vm.count.hours) + " "), _c('span', {
    staticClass: "time"
  }, [_vm._v("hour"), (_vm.count.hours > 1) ? _c('span', [_vm._v("s")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.count.minutes) ? _c('span', [_vm._v("\n        " + _vm._s(_vm.count.minutes) + " "), _c('span', {
    staticClass: "time"
  }, [_vm._v("min"), (_vm.count.minutes > 1) ? _c('span', [_vm._v("s")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.count.minutes === 0 && _vm.remainingSeconds >= 0) ? _c('span', [_vm._v("\n        " + _vm._s(_vm.remainingSeconds) + " seconds\n      ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.saleState === 2) ? _c('span', [(_vm.count.days) ? _c('span', [_vm._v("\n        " + _vm._s(_vm.count.days) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.count.days === 0 && _vm.count.hours !== 0) ? _c('span', [_vm._v("\n        " + _vm._s(_vm.count.hours) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.count.hours === 0 && _vm.count.minutes !== 0) ? _c('span', [_vm._v("\n        " + _vm._s(_vm.count.minutes) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.count.minutes === 0) ? _c('span', [_vm._v("\n        " + _vm._s(_vm.remainingSeconds) + " seconds\n      ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.saleState === 3) ? _c('span', [_vm._v("\n      0 seconds\n    ")]) : _vm._e()]), _vm._v(" "), (_vm.saleState === 1) ? _c('div', {
    staticClass: "label"
  }, [(_vm.saleState === 1) ? _c('div', {
    staticClass: "label"
  }, [_vm._v("to start")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.saleState !== 1) ? _c('div', {
    staticClass: "label"
  }, [(_vm.count.days) ? _c('span', [_c('span', {
    staticClass: "time"
  }, [_vm._v("day"), (_vm.count.days > 1) ? _c('span', [_vm._v("s")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.count.days === 0 && _vm.count.hours !== 0) ? _c('span', [_c('span', {
    staticClass: "time"
  }, [_vm._v("hour"), (_vm.count.hours > 1) ? _c('span', [_vm._v("s")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.count.hours === 0 && _vm.count.minutes !== 0) ? _c('span', [_c('span', {
    staticClass: "time"
  }, [_vm._v("min"), (_vm.count.minutes > 1) ? _c('span', [_vm._v("s")]) : _vm._e()])]) : _vm._e(), _vm._v("\n  remaining\n  ")]) : _vm._e(), _vm._v(" "), _c('small', [_vm._v("Sale starts on block #" + _vm._s(_vm.initialBlock))]), _vm._v(" "), (_vm.saleState !== 1) ? _c('span', [_c('small', [_vm._v("Hidden cap revealed: 275,000 ether")])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 517:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "section grey"
  }, [_c('div', {
    staticClass: "ui container"
  }, [_c('h1', {
    staticClass: "ui header"
  }, [_vm._v("Founding Team")]), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "ui very relaxed very padded stackable grid"
  }, [_c('div', {
    staticClass: "four wide column"
  }, [_c('img', {
    staticClass: "ui middle aligned circular image",
    attrs: {
      "src": "https://aragon.one/rsc/imgs/about/luis.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "twelve wide column"
  }, [_c('h2', [_vm._v("Luis Cuende - Project Lead")]), _vm._v(" "), _c('p', [_vm._v("Luis has been awarded as the best underage European programmer in 2011, is a Forbes 30 Under 30, a MIT TR35 and was an Advisor to the VP of the European Commission.")]), _vm._v(" "), _c('p', [_vm._v("He cofounded the blockchain startup "), _c('a', {
    attrs: {
      "href": "https://stampery.com",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("Stampery")]), _vm._v(". Prior to founding startups, he created the world's first Linux distribution with facelogin.")]), _vm._v(" "), _c('a', {
    staticClass: "aragon underline green text",
    attrs: {
      "href": "https://blog.aragon.one/team-interviews-luis-aragons-project-lead-c4916bb3cfb4",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('i', {
    staticClass: "ui medium icon"
  }), _vm._v("Interview")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "inline-block",
      "width": "1rem"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "aragon underline blue text",
    attrs: {
      "href": "https://twitter.com/licuende",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('i', {
    staticClass: "ui twitter icon"
  }), _vm._v("licuende")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "inline-block",
      "width": "1rem"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "aragon underline grey text",
    attrs: {
      "href": "https://github.com/luisivan",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('i', {
    staticClass: "ui github icon"
  }), _vm._v("luisivan")])])]), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "ui very relaxed very padded stackable grid"
  }, [_c('div', {
    staticClass: "four wide column"
  }, [_c('img', {
    staticClass: "ui middle aligned circular image",
    attrs: {
      "src": "https://aragon.one/rsc/imgs/about/jorge.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "twelve wide column"
  }, [_c('h2', [_vm._v("Jorge Izquierdo - Tech Lead")]), _vm._v(" "), _c('p', [_vm._v("Curious hacker, creator of multiple apps for iOS, macOS and Pebble. Reached App Store's #2. Always tinkering with new tech.")]), _vm._v(" "), _c('p', [_vm._v("Already convinced about the decentralized future of the Internet, he has been building toy projects such as a "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://github.com/izqui/net",
      "rel": "noopener"
    }
  }, [_vm._v("mesh network")]), _vm._v(" or a small "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://github.com/izqui/blockchain",
      "rel": "noopener"
    }
  }, [_vm._v("blockchain implementation")]), _vm._v(" since 2014.")]), _vm._v(" "), _c('a', {
    staticClass: "aragon underline green text",
    attrs: {
      "href": "https://blog.aragon.one/team-interviews-jorge-aragons-tech-lead-dae54d7eacac",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('i', {
    staticClass: "ui medium icon"
  }), _vm._v("Interview")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "inline-block",
      "width": "1rem"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "aragon underline blue text",
    attrs: {
      "href": "https://twitter.com/izqui9",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('i', {
    staticClass: "ui twitter icon"
  }), _vm._v("izqui9")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "inline-block",
      "width": "1rem"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "aragon underline grey text",
    attrs: {
      "href": "https://github.com/izqui",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('i', {
    staticClass: "ui github icon"
  }), _vm._v("izqui")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "ui container"
  }, [_c('h1', {
    staticClass: "ui header"
  }, [_vm._v("Partners")]), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "ui very relaxed very padded stackable center aligned equal width grid"
  }, [_c('div', {
    staticClass: "middle aligned column"
  }, [_c('a', {
    attrs: {
      "href": "https://coinfund.io",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "ui middle aligned image",
    attrs: {
      "src": "https://aragon.one/rsc/imgs/partners/coinfund.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "middle aligned column"
  }, [_c('a', {
    attrs: {
      "href": "https://iconomi.net",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "ui middle aligned image",
    attrs: {
      "src": "https://aragon.one/rsc/imgs/partners/iconomi.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "middle aligned column"
  }, [_c('a', {
    attrs: {
      "href": "https://shapeshift.io",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "ui middle aligned image",
    attrs: {
      "src": "https://aragon.one/rsc/imgs/partners/shapeshift.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "middle aligned column"
  }, [_c('a', {
    attrs: {
      "href": "http://boost.vc",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "ui middle aligned image",
    attrs: {
      "src": "https://aragon.one/rsc/imgs/partners/boost.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "middle aligned column"
  }, [_c('a', {
    attrs: {
      "href": "http://wachsmanpr.com",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "ui middle aligned image",
    attrs: {
      "src": "https://aragon.one/rsc/imgs/partners/wachsman.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "middle aligned column"
  }, [_c('a', {
    attrs: {
      "href": "http://www.novakrutar.si/en/",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "ui middle aligned image",
    attrs: {
      "src": "https://aragon.one/rsc/imgs/partners/novakrutar.png"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "section grey"
  }, [_c('div', {
    staticClass: "ui container"
  }, [_c('h1', {
    staticClass: "ui header"
  }, [_vm._v("Advisors")]), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "ui very relaxed very padded stackable grid"
  }, [_c('div', {
    staticClass: "four wide column"
  }, [_c('img', {
    staticClass: "ui middle aligned circular image",
    attrs: {
      "src": "https://aragon.one/rsc/imgs/about/jake.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "twelve wide column"
  }, [_c('h2', [_vm._v("Jake Brukhman - Cofounder at CoinFund")]), _vm._v(" "), _c('p', [_vm._v("Cofounder of "), _c('a', {
    attrs: {
      "href": "http://coinfund.io",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("CoinFund")]), _vm._v(", a blockchain research company and private investment vehicle. Previously Partner & CTO at Triton Research, technical product manager and engineer at Amazon.com, and spent 5 years in financial technology in New York City.")]), _vm._v(" "), _c('p', [_vm._v("Technologist with a background in mathematics, computer science, distributed systems, web development, product management, private equity research, and startups.")]), _vm._v(" "), _c('a', {
    staticClass: "aragon underline blue text",
    attrs: {
      "href": "https://twitter.com/jbrukh",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('i', {
    staticClass: "ui twitter icon"
  }), _vm._v("jbrukh")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "inline-block",
      "width": "1rem"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "aragon underline grey text",
    attrs: {
      "href": "https://github.com/jbrukh",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('i', {
    staticClass: "ui github icon"
  }), _vm._v("jbrukh")])])]), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "ui very relaxed very padded stackable grid"
  }, [_c('div', {
    staticClass: "four wide column"
  }, [_c('img', {
    staticClass: "ui middle aligned circular image",
    attrs: {
      "src": "https://aragon.one/rsc/imgs/about/kenny.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "twelve wide column"
  }, [_c('h2', [_vm._v("Kenny Rowe - COO of Dai Foundation")]), _vm._v(" "), _c('p', [_vm._v("COO of Dai Foundation for "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://makerdao.com",
      "rel": "noopener"
    }
  }, [_vm._v("Maker DAO")]), _vm._v(", seeking to minimize the price volatility of its own stable token — the Dai — against the IMF’s international currency basket SDR.")]), _vm._v(" "), _c('p', [_vm._v("Founder of OnChain consulting. Seattle Ethereum Meetup organizer. Early adopter of Bitcoin and Ethereum.")]), _vm._v(" "), _c('a', {
    staticClass: "aragon underline blue text",
    attrs: {
      "href": "https://twitter.com/kennyrowe",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('i', {
    staticClass: "ui twitter icon"
  }), _vm._v("kennyrowe")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "inline-block",
      "width": "1rem"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "aragon underline grey text",
    attrs: {
      "href": "https://github.com/kennyrowe",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('i', {
    staticClass: "ui github icon"
  }), _vm._v("kennyrowe")])])]), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "ui very relaxed very padded stackable grid"
  }, [_c('div', {
    staticClass: "four wide column"
  }, [_c('img', {
    staticClass: "ui middle aligned circular image",
    attrs: {
      "src": "https://aragon.one/rsc/imgs/about/brayton.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "twelve wide column"
  }, [_c('h2', [_vm._v("Brayton Williams - Founding Partner at Boost VC")]), _vm._v(" "), _c('p', [_vm._v("Cofounder of "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://boost.vc",
      "rel": "noopener"
    }
  }, [_vm._v("Boost VC")]), _vm._v(", an accelerator programme making sci-fi a reality and one of the top blockchain investors. They invested in Stampery — Luis' previous company — and were first in investing in Luis and Jorge's new venture, which ended up becoming Aragon.")]), _vm._v(" "), _c('p', [_vm._v("Brayton has spent his career in finance working with too-big-to-fail Morgan Stanley in wealth management and then to a FinTech startup selling private company securities. Then in 2012 he joined his co-worker, Adam Draper, to start Boost VC.")]), _vm._v(" "), _c('a', {
    staticClass: "aragon underline blue text",
    attrs: {
      "href": "https://twitter.com/BraytonKey",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('i', {
    staticClass: "ui twitter icon"
  }), _vm._v("braytonkey")])])])])])])
}]}

/***/ }),

/***/ 518:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui fluid container black hero",
    attrs: {
      "id": "landing"
    }
  }, [_c('div', {
    staticClass: "ui stackable center aligned grid"
  }, [_c('div', {
    staticClass: "six wide left aligned middle aligned column"
  }, [_c('h1', {
    staticClass: "ui inverted header"
  }, [_vm._v("\n        Try the Aragon dapp\n        "), _c('div', {
    staticClass: "ui hidden half divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "sub header"
  }, [_vm._v("Create value without borders or intermediaries")])]), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _c('a', {
    staticClass: "ui huge aragon gradient button downloadButton",
    attrs: {
      "href": "https://github.com/AragonOne/aragon/releases/",
      "target": "_blank"
    }
  }, [_vm._v("Download Aragon Alpha")]), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _c('span', {
    staticClass: "white text",
    attrs: {
      "id": "weburl"
    }
  }, [_vm._v("or try out the "), _c('a', {
    attrs: {
      "href": "https://alpha.aragon.one",
      "target": "_blank"
    }
  }, [_vm._v("web version")])])]), _vm._v(" "), _c('div', {
    staticClass: "six wide column"
  }, [_c('div', {
    staticClass: "ui container"
  }, [_c('img', {
    staticClass: "ui fluid image",
    attrs: {
      "src": "https://aragon.one/rsc/imgs/screenshot.png",
      "id": "screenshot"
    }
  })])])])])
}]}

/***/ }),

/***/ 519:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section aragon diagonal gradient",
    attrs: {
      "id": "landing_community"
    }
  }, [_c('div', {
    staticClass: "ui middle aligned very relaxed center aligned stackable grid"
  }, [_c('div', {
    staticClass: "twelve wide column"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), (_vm.saleState === 0) ? _c('div', [_c('img', {
    staticClass: "ui small centered image",
    attrs: {
      "src": __webpack_require__(478)
    }
  }), _vm._v(" "), _vm._m(1)]) : _vm._e(), _vm._v(" "), (_vm.saleState !== 0) ? _c('div', [(_vm.ready) ? _c('div', {
    staticClass: "ui inverted two statistics"
  }, [(_vm.saleState !== 1) ? _c('ether') : _vm._e(), _vm._v(" "), (_vm.saleState !== 1) ? _c('dollar') : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _vm._m(2)]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "ui inverted header"
  }, [_vm._v("\n        Aragon Network token sale\n        "), _c('div', {
    staticClass: "ui hidden half divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "sub header"
  }, [_vm._v("Create and manage unstoppable organizations")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "ui inverted header"
  }, [_vm._v("\n          May 17th\n          "), _c('div', {
    staticClass: "sub header"
  }, [_vm._v("Exact time (block number) and address will be announced on Monday 15th")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "ui inverted header"
  }, [_vm._v("\n          🎉 Sale is closed! 🎉\n          "), _c('div', {
    staticClass: "sub header"
  }, [_vm._v("Thanks to everyone who participated.")])])
}]}

/***/ }),

/***/ 520:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "statistic"
  }, [_c('div', {
    staticClass: "value"
  }, [_vm._v("\n    $ " + _vm._s(_vm.count) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("\n    USD\n  ")])])
},staticRenderFns: []}

/***/ }),

/***/ 522:
/***/ (function(module, exports) {

module.exports = [
	{
		"constant": true,
		"inputs": [
			{
				"name": "_owner",
				"type": "address"
			}
		],
		"name": "name",
		"outputs": [
			{
				"name": "o_name",
				"type": "bytes32"
			}
		],
		"type": "function"
	},
	{
		"constant": true,
		"inputs": [
			{
				"name": "_name",
				"type": "bytes32"
			}
		],
		"name": "owner",
		"outputs": [
			{
				"name": "",
				"type": "address"
			}
		],
		"type": "function"
	},
	{
		"constant": true,
		"inputs": [
			{
				"name": "_name",
				"type": "bytes32"
			}
		],
		"name": "content",
		"outputs": [
			{
				"name": "",
				"type": "bytes32"
			}
		],
		"type": "function"
	},
	{
		"constant": true,
		"inputs": [
			{
				"name": "_name",
				"type": "bytes32"
			}
		],
		"name": "addr",
		"outputs": [
			{
				"name": "",
				"type": "address"
			}
		],
		"type": "function"
	},
	{
		"constant": false,
		"inputs": [
			{
				"name": "_name",
				"type": "bytes32"
			}
		],
		"name": "reserve",
		"outputs": [],
		"type": "function"
	},
	{
		"constant": true,
		"inputs": [
			{
				"name": "_name",
				"type": "bytes32"
			}
		],
		"name": "subRegistrar",
		"outputs": [
			{
				"name": "",
				"type": "address"
			}
		],
		"type": "function"
	},
	{
		"constant": false,
		"inputs": [
			{
				"name": "_name",
				"type": "bytes32"
			},
			{
				"name": "_newOwner",
				"type": "address"
			}
		],
		"name": "transfer",
		"outputs": [],
		"type": "function"
	},
	{
		"constant": false,
		"inputs": [
			{
				"name": "_name",
				"type": "bytes32"
			},
			{
				"name": "_registrar",
				"type": "address"
			}
		],
		"name": "setSubRegistrar",
		"outputs": [],
		"type": "function"
	},
	{
		"constant": false,
		"inputs": [],
		"name": "Registrar",
		"outputs": [],
		"type": "function"
	},
	{
		"constant": false,
		"inputs": [
			{
				"name": "_name",
				"type": "bytes32"
			},
			{
				"name": "_a",
				"type": "address"
			},
			{
				"name": "_primary",
				"type": "bool"
			}
		],
		"name": "setAddress",
		"outputs": [],
		"type": "function"
	},
	{
		"constant": false,
		"inputs": [
			{
				"name": "_name",
				"type": "bytes32"
			},
			{
				"name": "_content",
				"type": "bytes32"
			}
		],
		"name": "setContent",
		"outputs": [],
		"type": "function"
	},
	{
		"constant": false,
		"inputs": [
			{
				"name": "_name",
				"type": "bytes32"
			}
		],
		"name": "disown",
		"outputs": [],
		"type": "function"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"name": "_name",
				"type": "bytes32"
			},
			{
				"indexed": false,
				"name": "_winner",
				"type": "address"
			}
		],
		"name": "AuctionEnded",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"name": "_name",
				"type": "bytes32"
			},
			{
				"indexed": false,
				"name": "_bidder",
				"type": "address"
			},
			{
				"indexed": false,
				"name": "_value",
				"type": "uint256"
			}
		],
		"name": "NewBid",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"name": "name",
				"type": "bytes32"
			}
		],
		"name": "Changed",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"name": "name",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"name": "addr",
				"type": "address"
			}
		],
		"name": "PrimaryChanged",
		"type": "event"
	}
];

/***/ }),

/***/ 523:
/***/ (function(module, exports) {

module.exports = [
	{
		"constant": true,
		"inputs": [
			{
				"name": "_name",
				"type": "bytes32"
			}
		],
		"name": "owner",
		"outputs": [
			{
				"name": "",
				"type": "address"
			}
		],
		"type": "function"
	},
	{
		"constant": false,
		"inputs": [
			{
				"name": "_name",
				"type": "bytes32"
			},
			{
				"name": "_refund",
				"type": "address"
			}
		],
		"name": "disown",
		"outputs": [],
		"type": "function"
	},
	{
		"constant": true,
		"inputs": [
			{
				"name": "_name",
				"type": "bytes32"
			}
		],
		"name": "addr",
		"outputs": [
			{
				"name": "",
				"type": "address"
			}
		],
		"type": "function"
	},
	{
		"constant": false,
		"inputs": [
			{
				"name": "_name",
				"type": "bytes32"
			}
		],
		"name": "reserve",
		"outputs": [],
		"type": "function"
	},
	{
		"constant": false,
		"inputs": [
			{
				"name": "_name",
				"type": "bytes32"
			},
			{
				"name": "_newOwner",
				"type": "address"
			}
		],
		"name": "transfer",
		"outputs": [],
		"type": "function"
	},
	{
		"constant": false,
		"inputs": [
			{
				"name": "_name",
				"type": "bytes32"
			},
			{
				"name": "_a",
				"type": "address"
			}
		],
		"name": "setAddr",
		"outputs": [],
		"type": "function"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"name": "name",
				"type": "bytes32"
			}
		],
		"name": "Changed",
		"type": "event"
	}
];

/***/ }),

/***/ 524:
/***/ (function(module, exports) {

module.exports = [
	{
		"constant": false,
		"inputs": [
			{
				"name": "from",
				"type": "bytes32"
			},
			{
				"name": "to",
				"type": "address"
			},
			{
				"name": "value",
				"type": "uint256"
			}
		],
		"name": "transfer",
		"outputs": [],
		"type": "function"
	},
	{
		"constant": false,
		"inputs": [
			{
				"name": "from",
				"type": "bytes32"
			},
			{
				"name": "to",
				"type": "address"
			},
			{
				"name": "indirectId",
				"type": "bytes32"
			},
			{
				"name": "value",
				"type": "uint256"
			}
		],
		"name": "icapTransfer",
		"outputs": [],
		"type": "function"
	},
	{
		"constant": false,
		"inputs": [
			{
				"name": "to",
				"type": "bytes32"
			}
		],
		"name": "deposit",
		"outputs": [],
		"payable": true,
		"type": "function"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"name": "from",
				"type": "address"
			},
			{
				"indexed": false,
				"name": "value",
				"type": "uint256"
			}
		],
		"name": "AnonymousDeposit",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"name": "from",
				"type": "address"
			},
			{
				"indexed": true,
				"name": "to",
				"type": "bytes32"
			},
			{
				"indexed": false,
				"name": "value",
				"type": "uint256"
			}
		],
		"name": "Deposit",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"name": "from",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"name": "to",
				"type": "address"
			},
			{
				"indexed": false,
				"name": "value",
				"type": "uint256"
			}
		],
		"name": "Transfer",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"name": "from",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"name": "to",
				"type": "address"
			},
			{
				"indexed": false,
				"name": "indirectId",
				"type": "bytes32"
			},
			{
				"indexed": false,
				"name": "value",
				"type": "uint256"
			}
		],
		"name": "IcapTransfer",
		"type": "event"
	}
];

/***/ }),

/***/ 535:
/***/ (function(module, exports) {

module.exports = {
	"version": "0.18.4"
};

/***/ }),

/***/ 557:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 558:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 559:
/***/ (function(module, exports) {

/* (ignored) */

/***/ })

},[286]);


// WEBPACK FOOTER //
// static/js/app.be717b7eca3acb2f309f.js